jQuery( document ).on( 'page.ready', function () {
	$ = jQuery;

	if ( $( 'main.collections' ).length ) {

		var smcontroller = new ScrollMagic.Controller();

		// Collections Slider Mobile
		// ---
		if ( $( window ).width() < 950 ) {
			setTimeout( function () {

				$( '.product-group .owl-carousel' ).each( function ( index, el ) {
					var $productsSlider = $( this );
					$productsSlider.owlCarousel( {
						nav: false,
						rewind: true,
						center: true,
						rewindSpeed: 0,
						dots: false,
						loop: true,
						lazyLoad: true,
						autoWidth: true
					} )
				} )

				var $collectionNav = $( ".collection-nav .owl-carousel" );
				$collectionNav.owlCarousel( {
					nav: false,
					rewind: true,
					center: true,
					rewindSpeed: 0,
					dots: false,
					loop: false,
					lazyLoad: true,
					autoWidth: true,
					onInitialized: fixStage
				} ).on( "dragged.owl.carousel", function ( event ) {
					var sections = $( 'main.collections' ).children( 'section' ),
						nextSection = sections[ event.item.index ],
						offsetHeight = ( ( $( '.collection-nav' ).outerHeight( true ) * 2 ) + $( '.menu-container' ).outerHeight( true ) );

					$( "html, body" ).animate( { scrollTop: ( $( nextSection ).offset().top - offsetHeight ) }, 500, "swing" );
				} );

				function fixStage( event ) {
					$( ".collection-nav .owl-carousel" ).each( function ( index, el ) {
						var $stage = $( this )
							.children( ".owl-stage-outer" )
							.children( ".owl-stage" ),
							$owlItems = $( $stage ).children(),
							totalWidth = 0;

						$( $owlItems ).each( function ( index, el ) {
							totalWidth += $( this ).outerWidth( true );
						} );

						$( $stage ).width( totalWidth + 1 );
					} );
				}

				$( document ).on( "click", ".collection-nav .owl-item", function () {
					var sections = $( 'main.collections' ).children( 'section' ),
						nextSection = sections[ $( this ).index() ],
						offsetHeight = ( ( $( '.collection-nav' ).outerHeight( true ) * 2 ) + $( '.menu-container' ).outerHeight( true ) );

					$( "html, body" ).animate( { scrollTop: ( $( nextSection ).offset().top - offsetHeight ) }, 500, "swing" );
					$collectionNav.trigger( "to.owl.carousel", $( this ).index() );
				} );

				$( ".product-group" ).each( function () {
					var me = $( this );
					var showFromBot = new ScrollMagic.Scene( {
							triggerElement: this,
							triggerHook: .2,
							reverse: true
						} )
						.on( "start", function ( event ) {
							$collectionNav.trigger( "to.owl.carousel", $( me ).data( 'index' ) );
						} )
						//.addIndicators()
						.addTo( smcontroller );
				} );​

			}, 0 );
		}

		if ( $( window ).width() >= 767 ) {
			$( ".product-group" ).each( function () {
				var me = $( this ),
					trigger = $( me ).children().children( '.products' );
				var showFromBot = new ScrollMagic.Scene( {
						triggerElement: this,
						triggerHook: .3,
						duration: ( ( window.innerHeight / 100 ) * 90 ),
						reverse: true
					} )
					.on( "enter", function ( event ) {
						var allNav = $( '.collection-nav >.container' ).children();
						$( allNav ).removeClass( 'active' );
						$( allNav[ $( me ).data( 'index' ) ] ).addClass( 'active' );
					} )
					.on( "leave", function ( event ) {
						var allNav = $( '.collection-nav >.container' ).children();
						$( allNav[ $( me ).data( 'index' ) ] ).removeClass( 'active' );
					} )
					//.addIndicators()
					.addTo( smcontroller );
			} );​

			$( document ).on( "click", ".collection-nav button", function () {
				var sections = $( 'main.collections' ).children( 'section' ),
					nextSection = sections[ $( this ).index() ],
					offsetHeight = ( ( $( '.collection-nav' ).outerHeight( true ) * 2.23 ) + $( '.menu-container' ).outerHeight( true ) ),
					allNav = $( '.collection-nav >.container' ).children();

				$( allNav ).removeClass( 'active' );
				$( this ).addClass( 'active' );
				$( "html, body" ).animate( { scrollTop: ( $( nextSection ).offset().top - offsetHeight ) }, 500, "swing" );
			} );
		}

		if ( $( window ).width() >= 950 ) {
			setTimeout( function () {
				$( '.product-group .owl-carousel' ).each( function ( index, el ) {

					var $productsSlider = $( this );
					$productsSlider.owlCarousel( {
						nav: true,
						rewind: true,
						rewindSpeed: 0,
						dots: false,
						loop: false,
						lazyLoad: true,
						autoWidth: true,
						onInitialized: fixDesktop,
						navText: [
							'<svg xmlns="http://www.w3.org/2000/svg" width="103.324" height="51.143" viewBox="0 0 103.324 51.143"><g transform="translate(-6 -5.379)"><path style="fill: none;stroke: #231f20;stroke-linecap: round;stroke-linejoin: round;stroke-width: 3px" d="M107.824 18H7.5" transform="translate(0 12.95)"/><path style="fill: none;stroke: #231f20;stroke-linecap: round;stroke-linejoin: round;stroke-width: 3px" d="M30.95 54.4L7.5 30.95 30.95 7.5"/></g></svg>',
							'<svg xmlns="http://www.w3.org/2000/svg" width="103.324" height="51.143" viewBox="0 0 103.324 51.143"><g transform="rotate(180 50.912 24.51)"><path style="fill: none;stroke: #231f20;stroke-linecap: round;stroke-linejoin: round;stroke-width: 3px" d="M100.324 0H0" transform="translate(0 23.45)"/><path style="fill: none;stroke: #231f20;stroke-linecap: round;stroke-linejoin: round;stroke-width: 3px" d="M23.45 46.9L0 23.45 23.45 0"/></g></svg>'
						]
					} )
				} )

				function fixDesktop( event ) {

					var $theSlider = event.target,
						$theStage = $( $theSlider ).children().children( '.owl-stage' ),
						stageWidth = ( $( $theStage ).width() + event.item.count );

					if ( $( $theStage ).width() >= $( window ).width() ) {} else {
						var temp = $( $theSlider ).children( '.owl-nav' );
						$( temp ).remove();
					}

					setTimeout( function () {
						$( $theStage ).css( 'width', stageWidth + 'px' );
					}, 0 );

				}

			}, 0 );
		}

	}

} );